import React from 'react';
import { LucideIcon } from 'lucide-react';

interface HubActionCardProps {
    title: string;
    description: string;
    icon: LucideIcon;
    onClick: () => void;
    accentColor?: string;
}

export const HubActionCard: React.FC<HubActionCardProps> = ({
    title,
    description,
    icon: Icon,
    onClick,
    accentColor = 'bg-blue-50 text-blue-600 dark:bg-blue-900/20 dark:text-blue-400',
}) => {
    return (
        <button
            type="button"
            onClick={onClick}
            className="bg-light-card dark:bg-dark-card border border-[0.6px] border-light-border/30 dark:border-dark-border/30 rounded-xl shadow-sm hover:shadow-md transition-all p-5 text-left w-full group"
        >
            <div className="flex items-start justify-between gap-4">
                <div>
                    <p className="text-base font-semibold text-primary dark:text-primary">
                        {title}
                    </p>
                    <p className="text-sm text-light-subtle dark:text-dark-subtle mt-1">
                        {description}
                    </p>
                </div>
                <div
                    className={`p-3 rounded-lg ${accentColor} flex items-center justify-center`}
                >
                    <Icon size={20} />
                </div>
            </div>
            <div className="mt-4 text-sm font-medium text-primary dark:text-golden opacity-0 group-hover:opacity-100 transition-opacity">
                Manage →
            </div>
        </button>
    );
};
